import { API } from "aws-amplify";
import { validateCrashingShifts } from "../../punonjesit/EmployeeView/Payment/EmployeeShifts/utils/apiHelpers";
import swal from "sweetalert";
import moment from "moment-timezone";
import dayjsTZ from "../../../utils/dayjs";
import { message } from "antd";

export const matchDepartamentWithEmployee = (departmentId, departments) => {
  let res = departments.filter((el) => el.departmentId === departmentId);
  if (res.length > 0) {
    return res[0].departmentName;
  } else {
    return null;
  }
};

export const createNewShiftByAdmin = async (
  shiftData,
  employeeId,
  employeeRequests
) => {
  let valid = await validateCrashingShifts(shiftData, employeeId, null);
  // let req = await validateRequests(shiftData, employeeId, employeeRequests);
  // let afterMidnight = await afterMidnight(shiftData, employeeId);
  // console.log("request", req);
  // if (req === false) {
  // 	message.error("Ju nuk mund te shtoni pasi ka kerkese leje!");
  // 	return Promise.reject(["", ""]);
  // }

  console.log("valid", valid);

  // must comment?
  // let lower_limit = dayjsTZ(shiftData.clockInDate);
  // lower_limit = lower_limit
  //   .set("hour", "00")
  //   .set("minute", "00")
  //   .set("second", "00");

  // let higher_limit = dayjsTZ(shiftData.clockInDate);
  // higher_limit = higher_limit
  //   .set("hour", "07")
  //   .set("minute", "30")
  //   .set("second", "00");

  // must comment?
  // shiftData.clockingCategory =
  //   dayjsTZ(shiftData?.clockInDate).valueOf() <= dayjsTZ(higher_limit).valueOf()
  //     ? "midnightReset"
  //     : shiftData?.clockingCategory;

  if (valid.value === true) {
    return API.post("clocking", `/clocking`, {
      body: {
        clockingCategory: "midnightReset",
        ...shiftData,
      },
    }).then(
      (res) => res
      // API.post("clockingLogs", "/clockingLogs", {
      //   body: {
      //     clockingId: clockingId,
      //     createdAt: moment().valueOf(),
      //     username: adminLog.username,
      //     note: "Shtim Turni Manual",
      //     newShift: [{ clockInDate: shiftData.clockInDate, clockOutDate: shiftData.clockOutDate }],
      //   },
      // })
    );
  } else {
    // swal({
    //   title: `Ju nuk mund te shtoni kete turn ne kete orar sepse ka te pakten nje turn qe ka perplasje:
    //   ${moment(valid.crashShift.clockInDate).format("HH:mm")}
    //    - ${moment(valid.crashShift.clockOutDate).format("HH:mm")}
    //   `,
    //   icon: "error",
    //   className: "custum-swal",
    // });
    return Promise.reject([valid.crashShift, shiftData]);
  }
};

const validateRequests = async (shiftData, employeeId, employeeRequests) => {
  let userSub;
  await API.get("employees", `/employees/${employeeId}`).then(
    (res) => (userSub = res)
  );
  let appliedRequest = employeeRequests.filter(
    (el) =>
      el.userSub === userSub.userSub &&
      el?.requestStatus === "APPROVED" &&
      el.requestPeriod.some(
        (period) =>
          dayjsTZ(period).format("DD/MM/YYYY") ===
          dayjsTZ(shiftData.clockInDate).format("DD/MM/YYYY")
      )
  );
  if (appliedRequest.length > 0) {
    return false;
  }
  return true;
};
